module.exports = __webpack_public_path__ + "a4c8fd01023299fdd2194124c00855b1.png";